// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__XhTq8","modal_content":"modal_modal_content__TKjUx","modal_dialog":"modal_modal_dialog__0K62k","overlay":"modal_overlay__D1Rh8"};